// extracted by mini-css-extract-plugin
export default {"searchInput":"Search_searchInput__YFGBW","inputElement":"Search_inputElement__+Ulyq","searchIcon":"Search_searchIcon__yhevP"};